import React from "react";
import { AgentButton } from "@fidget/common/components/inputs/buttons/agentButton/agentButton";

interface Props {
  widgetId: string;
  name: string;
  sendMessage: () => void;
  icon?: string;
}

export const MessageWidgetButton = ({ widgetId, sendMessage, name, icon = "icon-doc" }: Props) => {
  return (
    <AgentButton id={"message_widget" + widgetId} icon={icon} fullWidth onClick={sendMessage}>
      {name}
    </AgentButton>
  );
};
